import { __assign } from "tslib";
import React, { useEffect, useRef } from 'react';
import ErrorBoundary from '../../ErrorBoundary';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import { useDismissableNotification } from './useDismissableNotification';
export var Duration = {
    XS: 2000,
    S: 2500,
    M: 6000,
    XL: 10000,
};
function getDuration(isMultiline, actionCount) {
    if (isMultiline === void 0) { isMultiline = false; }
    if (actionCount === void 0) { actionCount = 0; }
    if (!isMultiline) {
        if (!actionCount) {
            return Duration.XS;
        }
        if (actionCount === 1) {
            return Duration.S;
        }
        return Duration.M;
    }
    return Duration.XL;
}
var Notification = function (_a) {
    var id = _a.id, onOpenCallback = _a.onOpen, onCloseCallback = _a.onClose, queueName = _a.queueName, NotificationCard = _a.cardComponent, _b = _a.cardProps, cardProps = _b === void 0 ? {} : _b, children = _a.children;
    var immortalNotifications = useFlag('yumeruby');
    var customDuration = cardProps.hasOwnProperty('duration');
    var _c = useDismissableNotification({
        id: id,
        queueName: queueName,
        duration: immortalNotifications
            ? 9999999
            : customDuration
                ? cardProps.duration
                : getDuration(cardProps.multiLine, cardProps.actions && cardProps.actions.length),
        onCloseCallback: onCloseCallback,
    }), onClose = _c.onClose, onPause = _c.onPause, onUnpause = _c.onUnpause;
    var rootRef = useRef(null);
    useEffect(function () {
        rootRef.current && onOpenCallback && onOpenCallback(id, rootRef.current);
    }, [id, onOpenCallback]);
    return (React.createElement(ErrorBoundary, { debugComponent: "Notifcation" },
        React.createElement(NotificationCard, __assign({}, cardProps, { rootRef: rootRef, onClose: onClose, onMouseEnter: onPause, onMouseLeave: onUnpause }), children)));
};
Notification.displayName = 'Notification';
export default Notification;
//# sourceMappingURL=Notification.js.map